import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-us-page">
      {/* Hero Section */}
      <section className="about-us-hero">
        <div className="hero-background"></div>
        <div className="hero-gradient"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>About <span>S. V. Gadag Ginning Factory</span></h1>
              <p className="lead">
                A renowned processor and exporter of Agro commodities, specializing in the export of 
                Groundnut Seeds, Groundnut In-Shell, and its variants for the past 26 years.
              </p>
            </div>
            <div className="hero-visual">
              <div className="company-badges">
                <div className="badge-item">
                  <i className="fa fa-star"></i>
                  <span>3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House</span>
                </div>
                <div className="badge-item">
                  <i className="fa fa-certificate"></i>
                  <span>ISO Certified</span>
                </div>
                <div className="badge-item">
                  <i className="fa fa-shield"></i>
                  <span>HACCP</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="section company-intro" id="about-intro">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="company-image">
                <img 
                  src="/assets/cashews-impo.jpg" 
                  alt="S. V. Gadag Ginning Factory" 
                  className="img-responsive"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="company-info">
                <p className="info-titlesml">"3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House"</p>
                <h2>Recognized by <br /> <span>Government of India.</span></h2>
                <p>
                  S. V. GADAG(SVG) Ginning Factory is a renowned processor and exporter of Agro commodities, 
                  specializing in the export of Groundnut Seeds, Groundnut In-Shell, and its variants for 
                  the past 26 years.
                </p>
                <p>
                  An <strong>ISO 22000:2005</strong>, HACCP certified company, SVG is a GoI recognized 
                  3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House and has made its strong foothold with <strong>120+ importers </strong> 
                  spanning across Asian countries – Indonesia, Philippines, Malaysia, Thailand, Singapore, 
                  SriLanka, Vietnam, Kuwait and China. The company is identified as a member organization 
                  by <strong>STAR EXPORT HOUSE, ISO, MSME, APEDA, IOPEPC, KSSAI, VTPC, FIEO, FSSAI.</strong>
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div className="company-details">
                <div className="detail-item">
                  <ul>
                    <li><i className="fa fa-check"></i> Origin</li>
                  </ul>
                  <p>
                    It all started when <strong>Mr. Sharan Gadag</strong> founded our company. Our headquarters are situated in
                    <strong>Gadag</strong> district of Karnataka, India, with an additional unit in Gujarat.
                  </p>
                </div>
                <div className="detail-item">
                  <ul>
                    <li><i className="fa fa-check"></i> The journey…</li>
                  </ul>
                  <p>
                    <strong>Mr. Sharan Gadag</strong> created a competent and dynamic team that brings in the required expertise. 
                    Today, SVG has grown to a sizable company with its steady performance year after year, built 
                    on its strong market goodwill, maintaining consistency in quality and a network of quality-driven 
                    suppliers for our products.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section why-choose-svg" id="why-choose-svg">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="why-choose-content">
                <div className="icon-section">
                  <i className="fa fa-building"></i>
                  <h3>Why choose <span>S. V. Gadag Ginning Factory?</span></h3>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    <ul className="features-list">
                      <li>Premium grade products with quality at international standards.</li>
                      <li>More than a decade of experience.</li>
                      <li>Spacious infrastructure with plant size covering over 16000 sq ft.</li>
                      <li>
                        Wide distribution network with <strong>120+ Importers, 26+ years Export Experience, 
                        [Indonesia, Philippines, Malaysia, Thailand, Singapore, SriLanka, Vietnam, Kuwait, China] 
                        Export Countries.</strong>
                      </li>
                      <li>Profound quality awareness.</li>
                      <li>Customer-oriented approach.</li>
                      <li>Packaging process.</li>
                      <li>
                        Well experienced team of professionals skilled in <strong>Purchasing, Quality Assurance, 
                        Processing, Packaging, Supply Chain</strong>, and other areas.
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-4">
                    <div className="features-image">
                      <img 
                        src="/assets/peanuts-show.png" 
                        alt="Peanuts" 
                        className="img-responsive"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Summary */}
      <section className="section business-summary" id="work">
        <div className="container">
          <div className="row">
            <div className="col-sm-6">
              <div className="title-section">
                <p className="lead">S. V. GADAG GINNING FACTORY</p>
                <h2 className="title-a">Our Business Summary <br />started with Ambiguous Fame</h2>
              </div>
            </div>
            <div className="col-md-6">
              <div className="summary-content">
                <p>
                  An <strong>ISO 22000:2005</strong>, HACCP certified company, SVG is a GoI recognized 
                  <strong> 3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House</strong> and has made its strong foothold with 
                  <strong> 120+ importers</strong> spanning across Asian countries – Indonesia, Thailand, 
                  Sri Lanka, Malaysia, and Philippines. <a href="#work">Let's See <i className="fa fa-long-arrow-right"></i></a>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <div className="work-box">
                <div className="work-img">
                  <img 
                    src="/assets/infrastructure/1.jpg" 
                    alt="S. V. Gadag Ginning Factory" 
                    className="img-responsive"
                  />
                  <div className="work-content text-center">
                    <h4 className="w-title">S. V. Gadag Ginning Factory</h4>
                    <div className="w-more">
                      <span className="w-ctegory">
                        A renowned Processor and Exporter of Agro Commodities since from past <strong>26 years</strong>.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <div className="work-img">
                  <img 
                    src="/assets/infrastructure/3.jpg" 
                    alt="S. V. Gadag Ginning Factory" 
                    className="img-responsive"
                  />
                  <div className="work-content text-center">
                    <h4 className="w-title">S. V. Gadag Ginning Factory</h4>
                    <div className="w-more">
                      <span className="w-ctegory">
                        A renowned Processor and Exporter of Agro Commodities since from past <strong>26 years</strong>.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="work-box">
                <div className="work-img">
                  <img 
                    src="/assets/infrastructure/5.jpg" 
                    alt="S. V. Gadag Ginning Factory" 
                    className="img-responsive"
                  />
                  <div className="work-content text-center">
                    <h4 className="w-title">S. V. Gadag Ginning Factory</h4>
                    <div className="w-more">
                      <span className="w-ctegory">
                        A renowned Processor and Exporter of Agro Commodities since from past <strong>26 years</strong>.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications */}
      <section className="section certifications">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="clientele-hd">
                <h2>We are Certified & <br /> Recognized from</h2>
              </div>
            </div>
            <div className="col-md-9">
              <div className="certification-logos">
                <div className="logo-item">
                  <img src="/assets/logos/STAR-EXPORT-HOUSE-logo.jpg" alt="3 Star Export House" />
                  <h4>3 Star <i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i><i className="fa fa-star" style={{color: '#f39c12'}}></i> Export House</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/ISO-logo.jpg" alt="ISO" />
                  <h4>ISO Certified</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/MSME-ico.jpg" alt="MSME" />
                  <h4>MSME</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/APEDA-ico.jpg" alt="APEDA" />
                  <h4>APEDA</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/IOPEPC-ico.jpg" alt="IOPEPC" />
                  <h4>IOPEPC</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/KSSAI-ico.jpg" alt="KSSAI" />
                  <h4>KSSAI</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/FSSAI-ico.jpg" alt="FSSAI" />
                  <h4>FSSAI</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/HACCP-ico.jpg" alt="HACCP" />
                  <h4>HACCP</h4>
                </div>
                <div className="logo-item">
                  <img src="/assets/logos/FIEO-logo.jpg" alt="FIEO" />
                  <h4>FIEO</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="section contact-info">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="contact-item whatsapp-contact">
                <div className="contact-icon">
                  <svg className="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                  </svg>
                </div>
                <div className="contact-details">
                  <h5 style={{ color: 'white' }}>WhatsApp Us:</h5>
                  <p><a href="https://wa.me/919448165266?text=Hello! I'm interested in your peanut export services. Could you please provide more information?" style={{ color: '#25D366', textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">+91 944 816 5266</a></p>
                  <p><a href="https://wa.me/917975855377?text=Hello! I'm interested in your peanut export services. Could you please provide more information?" style={{ color: '#25D366', textDecoration: 'none' }} target="_blank" rel="noopener noreferrer">+91 797 585 5377</a></p>
                  <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem', fontStyle: 'italic' }}>Click to start a conversation instantly</p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fa fa-envelope"></i>
                </div>
                <div className="contact-details">
                  <h5 style={{ color: 'white' }}>Email Us:</h5>
                  <p><a href="mailto:svgadag_12@yahoo.com" style={{ color: '#ecf0f1', textDecoration: 'none' }}>svgadag_12@yahoo.com</a></p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="contact-item">
                <div className="contact-icon">
                  <i className="fa fa-phone"></i>
                </div>
                <div className="contact-details">
                  <h5 style={{ color: 'white' }}>Call Us:</h5>
                  <p><a href="tel:+919448165266" style={{ color: '#ecf0f1', textDecoration: 'none' }}>Tel: +91 944 816 5266</a></p>
                  <p><a href="tel:+917975855377" style={{ color: '#ecf0f1', textDecoration: 'none' }}>Tel: +91 797 585 5377</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
